import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { DepartureMonitorPage } from './departure-monitor.page';
import { DefaultStationGuard } from './default-station.guard';
import { StationsPage } from './stations/stations.page';

const routes: Routes = [
  {
    path: '',
    component: DepartureMonitorPage,
    canActivate: [DefaultStationGuard]
  },
  {
    path: 'stations',
    component: StationsPage
  },
  {
    path: ':stationId',
    component: DepartureMonitorPage,
    resolve: {
      departures: DefaultStationGuard
    }
  }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        DepartureMonitorPage, StationsPage
    ],
    exports: [StationsPage]
})
export class DepartureMonitorPageModule {}
